import { POSTS } from './mock';
import { CAMPAIGN_POSTS } from './campaign';
import { FR_POSTS } from './postsFr';
import { EDITORIAL_POSTS, resolvePublishedLinks } from './editorial';
import { filterPublished } from '../lib/publication';

function publishedPosts(posts) {
  const published = filterPublished(posts);
  const slugs = new Set(published.map(post => post.slug));
  return published.map(post => resolvePublishedLinks(post, slugs));
}

export const BLOG_CFG = {
  en: {
    posts: [...CAMPAIGN_POSTS, ...publishedPosts(POSTS)], base: '/blogs', home: '/', title: 'Blogs - Cursive Text Generator', heading: null,
    readMore: 'Read more »', back: 'All posts', recent: 'Recent Posts', ctaQ: 'Ready to try it yourself?', cta: 'Open the Cursive Generator',
    switchLabel: 'Lire en français', switchTo: '/fr/blog',
  },
  fr: {
    posts: publishedPosts([...EDITORIAL_POSTS, ...FR_POSTS]), base: '/fr/blog', home: '/fr/ecriture-cursive', title: 'Blog - Écriture Cursive', heading: 'Guides d’écriture stylée',
    sub: 'Instagram, pseudos, styles aesthetic et caractères spéciaux : des guides pratiques pour choisir, copier et tester votre texte.',
    readMore: 'Lire la suite »', back: 'Tous les articles', recent: 'Articles récents', ctaQ: 'Envie d’essayer ?', cta: 'Ouvrir le générateur d’écriture cursive',
    switchLabel: 'Read in English', switchTo: '/blogs',
  },
};
